export enum TypeColorVisualization {
  COLOR_NAME = 1,
  DETAIL_COLOR = 2,
}
